import { localeLoaders } from './loader';
import { LocaleCode } from './constants';

const loadCustomL10nJSON = async (lang: string) => {
  const url = `${process.env.PUBLIC_URL}/l10n/${lang}.json`;
  try {
    const request = await fetch(url);
    const json = await request.json();

    return json;
  } catch (err) {
    console.error(`Cannot load custom dictionary from ${url}`, err);
  }
};

export const loadLocale = async (locale: string) => {
  const [builtinL10n, customL10n] = await Promise.all([
    localeLoaders[locale as LocaleCode](),
    loadCustomL10nJSON(locale),
  ]);

  return {
    ...builtinL10n,
    ...customL10n,
  };
};
